import { jsx, jsxs } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import cx from "classnames";
import SSRIcon from "@ingka/ssr-icon";
import { string, bool, func, element, oneOfType, oneOf } from "prop-types";
const propTypes = {
  /** Prefix all classes in every element with this string */
  prefix: string,
  /** Text for the pill label */
  label: oneOfType([string, element]),
  /** Function that handles Button click */
  onClick: func,
  /** Pill selected state */
  selected: bool,
  /** Pill disabled state */
  disabled: bool,
  /** Enforces smaller pill size */
  size: oneOf(["xsmall", "small", "medium"]),
  /** Path to the thumbnail image */
  thumbnail: string,
  /** Function returning react element with paths for SSRIcon from `@ingka/ssr-icon/paths/[icon].js` */
  ssrIcon: func,
  /** Icon position (leading or trailing) */
  iconPosition: string,
  /** Specifies an alternate text for the thumbnail image */
  thumbnailAlt: string,
  /** Can be used to add classes to base HTML element. */
  className: string,
  /** Ensures no text is rendered, adds `.pill-icon` class if iconOnly && !thumbnail && ssrIcon */
  iconOnly: bool
};
const Pill = forwardRef((props, ref) => {
  const {
    prefix = "",
    iconOnly,
    label,
    selected,
    disabled,
    size = "medium",
    thumbnail,
    ssrIcon,
    iconPosition = "leading",
    thumbnailAlt,
    className,
    onClick,
    ...other
  } = props;
  const baseClass = `${prefix}pill`;
  const pillClasses = cx(
    `${baseClass}`,
    size !== "medium" && `${baseClass}--${size}`,
    iconOnly && ssrIcon && !thumbnail && `${baseClass}--icon`,
    !iconOnly && ssrIcon && !thumbnail && `${prefix}${iconPosition}-icon`,
    thumbnail && `${baseClass}--thumbnail`,
    selected && !disabled && `${baseClass}--active`,
    className
  );
  return /* @__PURE__ */ jsxs(
    "button",
    {
      ref,
      className: pillClasses,
      disabled,
      "aria-pressed": selected ? "true" : "false",
      onClick,
      ...other,
      children: [
        thumbnail && /* @__PURE__ */ jsx("img", { className: `${baseClass}__thumbnail`, src: thumbnail, alt: thumbnailAlt }),
        ssrIcon && !thumbnail && /* @__PURE__ */ jsx(SSRIcon, { prefix, paths: ssrIcon, className: `${baseClass}__icon` }),
        label && /* @__PURE__ */ jsx("span", { className: `${baseClass}__label`, children: label })
      ]
    }
  );
});
Pill.propTypes = propTypes;
Pill.displayName = "Pill";
var Pill_default = Pill;
export {
  Pill_default as default
};
